



























































import {Component, Vue} from 'vue-property-decorator';
import {
  Getter,
  Action,
} from 'vuex-class';

@Component
export default class Login extends Vue {
  public $refs!: {
    form: any,
  };

  @Action('auth/changePassword') private changePassword!: (user: any) => Promise<any>;

  @Getter('auth/user') private user!: any;

  private loading: boolean = false;
  private localUser: any = {
    username: null,
    oldPassword: null,
    newPassword: null,
  };
  // @Getter('rules/all') private rules!: any[];

  public mounted() {
    if (this.user.email) {
      this.localUser.username = this.user.email;
    }
  }

  private async signIn(e: Event) {
    e.preventDefault();
    this.loading = true;
    const success = await this.changePassword(this.localUser);
    this.loading = false;
    if (success) {
      this.$router.push({name: 'Home'});
    }
  }
}
